module.exports = __webpack_public_path__ + "img/stop_zh.56ef3bcf.png";